import React, { Component } from 'react';
import { ReactiveBase, MultiList, ResultCard, DataSearch, RatingsFilter, ReactiveList, SelectedFilters } from '@appbaseio/reactivesearch';
import DisplayStarIcons from '../Utils/DisplayStarIcons'
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { addURL } from '../Utils/Actions';
import { Button } from 'react-bootstrap';

const components = {
  settings: {
    app: "rate-review-repeat",
    credentials: "J2VtlWoNW:86694908-5edd-48c4-9d89-1ef5081148d8"
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addURL: url => dispatch(addURL(url))
  };
}

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: ""
    };
    this.handleChange = this.handleChange.bind(this);
    //console.log(this.props.getState());

  }


  handleChange(value) {

    this.props.history.push("/review?searchTerm=" + value)

  }

  defaultQuery() {
    return {
      "query": {
        "exists": {
          "field": "rating"
        }
      }
    };
  }


  render() {



    return (

      <div className="main-container">
        <ReactiveBase {...components.settings}
        >

          <div className="home-sub-container">


            <div className="result-container" >
              <div className="searchbar">

                <div className="home-search-container">
                  <h2 className="bold-font blackColor">Rate your experience. Write reviews. Repeat.</h2>

                  <DataSearch componentId="searchTerm"
                    dataField={["company"]}
                    className="search-bar"
                    URLParams={true}
                    onValueSelected={this.handleChange}
                    queryFormat="and"
                    placeholder="Search for company reviews..."  >

                  </DataSearch>
                </div>
              </div>
              <SelectedFilters {...components.selectedFilters} />
              <ReactiveList
                componentId="results"
                dataField="company"
                pagination={true}
                className="Result_card"
                paginationAt="bottom"
                pages={3}
                size={4}
                Loader="Loading..."
                noResults="No results were found..."
                defaultQuery={this.defaultQuery}

                innerClass={{
                  title: "result-title",
                  listItem: "result-item",
                  list: "list-container",
                  sortOptions: "sort-options",
                  resultStats: "result-stats",
                  resultsInfo: "result-list-info"
                }}
              >
                {({ data }) => (

                  <ReactiveList.ResultCardsWrapper>
                    {data.map(item => (
                      <div key={item._id} className="col-sm-12 col-md-4 col-lg-3">
                        <div className="ih-item square effect6 top_to_bottom">
                          <Link to={{ pathname: `/rate-company/${item._id}`, state: { companyName: item.company } }} >
                            <div className="card text-white bg-white mb-3 item-box">
                              <h3 className='bold-font blackColor'>{item.company}</h3>
                              <span className='blackColor bold-semifont para'>
                                {DisplayStarIcons(item.rating)} ({item.rating})
                              </span>
                              <p className='light-font para mt-2'>{item.categories}</p>
                              <Button className='round-button width-100 light-font'>Review Now</Button>
                              {/* <button className='themeBgColor light-font'>Review Now</button> */}
                              {/* <div className="card-header">
                                <Image src={DisplayStars(item.rating)} fluid />
                              </div>
                              <div className="card-body">
                                <h4 className="card-title">{item.company}</h4>
                                <p className="card-text">{item.address}</p>
                              </div>
                              <div className="info colored">
                                <h3 className="overlay-title">
                                  Phone: {item.phone}
                                </h3>

                                <div className="overlay-description">
                                  {item.categories}
                                </div>
                              </div> */}
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))}
                  </ReactiveList.ResultCardsWrapper>
                )}
              </ReactiveList>
            </div>

          </div>

        </ReactiveBase>

      </div>



    );
  }

}

export default withRouter(connect(null, mapDispatchToProps)(Search));
